export class Activite {
    static readonly jsonMap = {
        id: { key: 'id' },
        code: { key: 'code' },
        libelle: { key: 'libelle' }
    };

    public id: number = undefined;
    public code: string = undefined;
    public libelle: string = undefined;
}
